import { Address } from '@cinch-labs/sites-sdk'
import styles from './location-card.module.css'
import { BaseCard, Secondary, Text } from '@cinch-labs/design-system'
import { formatSiteAddress } from '@cinch-nx/shared-sites'

export interface LocationCardData {
  siteName: string
  distance: number
  slug: string
  address: Address
}

interface CardButtonProps {
  onClick: () => void
  buttonText: string
}

interface LocationCardProps {
  card: LocationCardData
  button: CardButtonProps
}

export const LocationCard = ({
  card: { siteName, distance, address, slug },
  button: { onClick, buttonText },
}: LocationCardProps) => (
  <BaseCard className={styles.locationCardWrapper}>
    <div className={styles.upperCard}>
      <Text fontWeight="bold">{siteName}</Text>
      <div className={styles.distancePill}>
        <Text fontSize="s" fontWeight="semibold" color="deepPurple">
          {distance} miles away
        </Text>
      </div>
    </div>
    <div className={styles.lowerCard}>
      <address className={styles.address}>
        <Text fontSize="m">{formatSiteAddress(address)}</Text>
      </address>
      <Secondary
        element="a"
        size="small"
        href={`/cars-near-me/collection-location/${slug}`}
        onClick={onClick}
      >
        {buttonText}
      </Secondary>
    </div>
  </BaseCard>
)
